const env = {
    environment:"development",
    basicPlanPrice: 1,
    proPlanPrice: 1,
    devConfig: {
        apiKey: "AIzaSyBu-eg7LaW9Q3fGTwxMepWYkdFu6we8o3w",
        authDomain: "awesome-67f16.firebaseapp.com",
        databaseURL: "https://awesome-67f16.firebaseio.com",
        projectId: "awesome-67f16",
        storageBucket: "awesome-67f16.appspot.com",
        messagingSenderId: "18312616735",
        appId: "1:18312616735:web:42498db203741426",
      },
    prodConfig: {
        apiKey: 'AIzaSyD3XuruW5iJxnrdoYtIq8WaJ2dZZ9t_6dI',
        authDomain: 'orsity-77bca.firebaseapp.com',
        databaseURL:'https://orsity-77bca.firebaseio.com',
        projectId: 'orsity-77bca',
        storageBucket: 'orsity-77bca.appspot.com',
        messagingSenderId: '600294265200'
      },
    stripeDevConfig:{
      api_key:"pk_test_ZERMpljhQkaxrGGw3AJXozhe00HWeE5I6B",
    },
    stripeProdConfig:{
      api_key:"pk_live_P8qkVHuMATyXEE7GN3nUYrfF004Mq5Oi9K",
    },
    gaDevConfig: {
      api_key: "UA-141254607-1"
    },
    gaProdConfig: {
      api_key: "UA-142375704-1"
    }
}

export default env;